import BaseApp from "../BaseApp";
import UIModal from "../../classes/modals/UIModal";


export default class AuthWatcherApp extends BaseApp {

    onReady() {
        system.socketClient.subscribeTo(
            "another_device_detected",
            this.onDetectAnotherDevice.bind(this)
        );

        system.socketClient.subscribeTo(
            "somebody_kick_you",
            this.onKick.bind(this)
        );
    }

    onDetectAnotherDevice() {
        UIModal.warning("somebody_try_login");
    }

    onKick() {
        UIModal.error({
            text: "somebody_kick_you",
            okText: "login",
            buttons: {
                cancel: false
            },
            onDestroy() {
                // show login page
                window.location.reload();
            }
        });
    }
}
